import React from 'react'

let Medie = () =>
    <article>
        <h1>Medie</h1>
        <p>La sezione Medie offre all'utente la possibilità di visualizzare i dati medi giornalieri, su tutti i parametri disponibili nel menu di fianco, in un arco temporale scelto a piacere usando il tasto “SCEGLI PERIODO”. Il Tecnico di campo ha, in questa sezione, la possibilità di avere disponibile in maniera sinottica l'andamento giornaliero del valore medio dei parametri che hanno interesse ad essere monitorati, in modo tale da poter tenere sotto controllo lo sviluppo di patologie crittogame o il pullulare di insetti dannosi.</p>
    </article>

export default Medie